import React from "react";
import { ErrorPage } from "./ErrorPage";

export const NotFoundPage: React.FC = () => {
  return (
    <ErrorPage
      title="Not Found"
      heading="We couldn't find that page"
      body="We're sorry, but that page may have been moved or deleted."
      metaTitle="Page Not Found - Tennr"
      metaDescription="The page you're looking for couldn't be found."
    />
  );
};